import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLinebreak: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLinebreak"><Path fillRule="evenodd" clipRule="evenodd" d="M3 4H21V6H3V4ZM3 11H16.75C19.2353 11 21.25 13.0147 21.25 15.5C21.25 17.9853 19.2353 20 16.75 20H14.4142L15.9142 21.5L14.5 22.9142L10.5858 19L14.5 15.0858L15.9142 16.5L14.4142 18H16.75C18.1307 18 19.25 16.8807 19.25 15.5C19.25 14.1193 18.1307 13 16.75 13H3V11ZM3 18H8V20H3V18Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLinebreak;
